import Vue from 'vue';
import App from './App.vue';
import vSelect from 'vue-select'

Vue.component('v-select', vSelect)
import 'vue-select/dist/vue-select.css';

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import AWS from 'aws-sdk';
import Amplify, { Auth } from 'aws-amplify';
import awsconfig from './aws-exports';
import '@aws-amplify/ui-vue';
Amplify.configure(awsconfig);

Vue.config.productionTip = false;


new Vue({
  render: (h) => h(App),
}).$mount('#app');
